import React, { useEffect, useState } from 'react'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useRef } from 'react';

export default function BuilderSlider({
  getCurrentSelectValue,
  activeTab,
  items = ["Straight Bet", "Parlay Bet", "Teaser", "Call Bets"],
}) {
    const scrollLevel = 120
    const sliderRef = useRef(null);
    const [selectValue, setSelectedValue] = useState(activeTab || "Straight Bet");
    const [disable, setDisable] = useState({ leftBtn: false, rightBtn: false });

    const scrollLeft = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({
                left: -scrollLevel,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({
                left: scrollLevel,
                behavior: 'smooth'
            });
        }
    };

    const selectHandle = (item) => {
        setSelectedValue(item);
    };

    const [isScrollable, setIsScrollable] = useState(false);

    const updateScrollState = () => {
        if (!sliderRef.current) return;
        const { scrollWidth, clientWidth, scrollLeft } = sliderRef.current;
        const scrollable = scrollWidth > clientWidth;
        setIsScrollable(scrollable);
        if (scrollable) {
            setDisable({
                leftBtn: scrollLeft <= 1,
                rightBtn: scrollLeft + clientWidth >= scrollWidth - 1,
            });
        }
    };

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.scrollLeft = 0;
        }
        updateScrollState();
        window.addEventListener('resize', updateScrollState);
        return () => window.removeEventListener('resize', updateScrollState);
    }, []);

    useEffect(() => {
        const el = sliderRef.current;
        if (!el) return;
        el.addEventListener('scroll', updateScrollState);
        return () => el.removeEventListener('scroll', updateScrollState);
    }, [isScrollable]);

    useEffect(() => {
        requestAnimationFrame(updateScrollState);
    }, [isScrollable]);

    useEffect(() => {
        if (activeTab && activeTab !== selectValue) {
            setSelectedValue(activeTab);
        }
    }, [activeTab]);

    useEffect(() => {
        if (selectValue) {
            getCurrentSelectValue(selectValue);
        }
    }, [selectValue]);

    return (
        <div className={`customSlider${isScrollable ? ' is-scrollable' : ''}`}>
            {isScrollable && (
                <button
                    onClick={scrollLeft}
                    className='customSliderLeftBtn'
                    disabled={disable.leftBtn}
                >
                    <IoIosArrowBack />
                </button>
            )}
            <ul
                ref={sliderRef}
            >
                {items.map((item) => (
                    <li key={item} className={`fs14 ${selectValue === item ? "isSelected" : ""}`} onClick={() => selectHandle(item)}>
                        {item}
                    </li>
                ))}
            </ul>
            {isScrollable && (
                <button
                    onClick={scrollRight}
                    className='customSliderRightBtn'
                    disabled={disable.rightBtn}
                >
                    <IoIosArrowForward />
                </button>
            )}
        </div>
    );
}
